import type { ReactNode } from "react";

interface ToolGridProps {
  children: ReactNode;
}

export default function ToolGrid({ children }: ToolGridProps) {
  return (
    <div
      className="flex gap-6 overflow-x-auto pb-4 scroll-smooth"
      style={{
        scrollbarWidth: "thin",
        scrollbarColor: "#000 #fff",
      }}
    >
      {children}
    </div>
  );
}
